module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_instagram-b993b3778919fbaa23c1a560c079af29.svg";